import { render } from "./PerfermanceTop5WidgetConfig.vue?vue&type=template&id=23ada3d2&scoped=true"
import script from "./PerfermanceTop5WidgetConfig.vue?vue&type=script&lang=js"
export * from "./PerfermanceTop5WidgetConfig.vue?vue&type=script&lang=js"

import "./PerfermanceTop5WidgetConfig.vue?vue&type=style&index=0&id=23ada3d2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23ada3d2"],['__file',"src/containers/widget/configs/PerfermanceTop5WidgetConfig.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "23ada3d2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('23ada3d2', __exports__)) {
    api.reload('23ada3d2', __exports__)
  }
  
  module.hot.accept("./PerfermanceTop5WidgetConfig.vue?vue&type=template&id=23ada3d2&scoped=true", () => {
    api.rerender('23ada3d2', render)
  })

}


export default __exports__